// extracted by mini-css-extract-plugin
module.exports = {"lastCommentsWrapper":"FlatComments_lastCommentsWrapper__2SNZM","openModalBtn":"FlatComments_openModalBtn__20ch7"};